import React from "react";

import * as Sticker from "ds/Sticker";

import * as S from "./EnterpriseMessage.style";

const EnterpriseMessage = ({ children }: { children: React.ReactNode }) => {
  return (
    <S.StickerRoot priority="information" variant="long">
      <Sticker.Icon priority="information" />
      <Sticker.Text>{children}</Sticker.Text>
    </S.StickerRoot>
  );
};

export default EnterpriseMessage;
